import React from "react";

interface Stats {
  total: number;
  upcoming: number;
  completed: number;
}

interface StatsCardProps {
  title: string;
  stats?: Stats;
  icon: React.ReactNode;
  color: string;
  loading?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  stats,
  icon,
  color,
  loading = false,
}) => (
  <div className="stats-card" style={{ borderLeftColor: color }}>
    <div className="stats-icon" style={{ backgroundColor: color }}>
      {icon}
    </div>
    <div className="stats-content">
      <h3>{title}</h3>
      <div className="stats-numbers">
        {loading ? (
          <div className="loading-spinner-small"></div>
        ) : (
          <>
            <div className="stat-item">
              <span className="stat-number">{stats?.total || 0}</span>
              <span className="stat-label">Total</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{stats?.upcoming || 0}</span>
              <span className="stat-label">Upcoming</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{stats?.completed || 0}</span>
              <span className="stat-label">Completed</span>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

export default StatsCard;
